import { create } from 'zustand';

interface UiState {
  selectedRunIdByProject: Record<string, string | null>;
  selectedTaskId: string | null;
  setSelectedRun: (projectId: string, runId: string | null) => void;
  setSelectedTask: (taskId: string | null) => void;
  clearSelection: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  selectedRunIdByProject: {},
  selectedTaskId: null,
  setSelectedRun: (projectId, runId) =>
    set((s) => ({
      selectedRunIdByProject: {
        ...s.selectedRunIdByProject,
        [projectId]: runId,
      },
    })),
  setSelectedTask: (taskId) => set({ selectedTaskId: taskId }),
  clearSelection: () => set({ selectedTaskId: null }),
}));
